'use strict';

import ngResource from 'angular-resource';

class SaConfigSearchService {
  constructor($resource) {
    'ngInject';
    this.oem_api = $resource(
      '/api/oem/sa_config_search/:id',
      {id: '@id'},
      {
        index: {method: 'GET', isArray: true},
        pageIndex: {method: 'GET', isArray: false},
      }
    )
  }
}

export default angular.module('leptonApp.SaConfigSearchService', ['ngResource'])
  .service('SaConfigSearchService', ['$resource', SaConfigSearchService])
  .name;



// WEBPACK FOOTER //
// ./public/dev/components/api/sa_config_search/sa_config_search.service.js